import { render } from "./FeaturedProductGrid.vue?vue&type=template&id=41e2ec03&scoped=true"
import script from "./FeaturedProductGrid.vue?vue&type=script&lang=js"
export * from "./FeaturedProductGrid.vue?vue&type=script&lang=js"

import "./FeaturedProductGrid.vue?vue&type=style&index=0&id=41e2ec03&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e2ec03"]])

export default __exports__